import { render, staticRenderFns } from "./SideLeft.vue?vue&type=template&id=2e1f545a&scoped=true"
import script from "./SideLeft.vue?vue&type=script&lang=js"
export * from "./SideLeft.vue?vue&type=script&lang=js"
import style0 from "./SideLeft.vue?vue&type=style&index=0&id=2e1f545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f545a",
  null
  
)

export default component.exports